

import { useSalUI } from './useSalUI';
import { useSalData } from './useSalData';
import { useSalIntelligence } from './useSalIntelligence';
import { useSalActions } from './useSalActions';
import { useSalProcesses } from './useSalProcesses';
import { GhostDispatchService } from '../services/ghostDispatchService';
import { TIMING } from '../constants';
import { useEffect, useMemo, useCallback } from 'react';

export const useSalEngine = () => {
  const data = useSalData();
  const ui = useSalUI();

  // Memoize cardapioWeb config to prevent unnecessary effect re-runs
  const cardapioWeb = useMemo(() => data.config?.cardapioWeb, [data.config]);
  const ghostDispatchEnabled = useMemo(
    () => cardapioWeb?.active && cardapioWeb?.enableGhostDispatch,
    [cardapioWeb]
  );

  // Memoize ghost dispatch service to prevent recreation on each render
  const ghostDispatchService = useMemo(
    () => GhostDispatchService({
      orders: data.orders,
      setOrders: data.setOrders,
      config: data.config,
    }),
    [data.orders, data.setOrders, data.config]
  );

  const { monitorOrdersForGhostDispatch } = ghostDispatchService;

  // Memoize the callback to prevent interval recreation
  const handleGhostDispatch = useCallback(() => {
    if (ghostDispatchEnabled) {
      monitorOrdersForGhostDispatch();
    }
  }, [monitorOrdersForGhostDispatch, ghostDispatchEnabled]);

  useEffect(() => {
    if (!ghostDispatchEnabled) return;

    const interval = setInterval(handleGhostDispatch, TIMING.GHOST_DISPATCH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [handleGhostDispatch, ghostDispatchEnabled]);

  // Injeção de storeId na inteligência para habilitar o Cache de Loja
  const intelligence = useSalIntelligence(
    data.orders,
    data.drivers,
    data.providers,
    data.config,
    data.context,
    data.storeId || undefined
  );

  const actions = useSalActions(data, ui);
  useSalProcesses(data, ui, intelligence, actions);

  return { ...data, ...ui, intelligence, actions, ui };
};
